import { isSomeFieldsTruthy } from 'utils/ob-helper/ob-helper';

export const handleActionsByEditingFields = ({
  editingFields,
  dirtyCallback,
  cleanCallback,
}) => {
  const isDirty = isSomeFieldsTruthy(editingFields);
  if (isDirty) dirtyCallback?.();
  else cleanCallback?.();
};
